export default "__VITE_ASSET__17dd9ee6__"